import { Navigate, createBrowserRouter } from 'react-router-dom';

import { ProtectedLayout } from './app/ProtectedLayout';
import { LoginPage } from './features/auth/pages/LoginPage';
import { UsersPage } from './features/users/pages/UsersPage';
import { AdminsPage } from './features/admins/pages/AdminsPage';
import { SettingsPage } from './features/settings/pages/SettingsPage';
import { DashboardPage } from './features/dashboard/pages/DashboardPage';
import { LogsPage } from './features/audit-log/pages/LogsPage';
import { MonitoringPage } from './features/monitoring/pages/MonitoringPage';

// PARA-106 §2 (UI-архитектура) — React Router v6 (createBrowserRouter):
// URL-адресная строка полезна здесь (шаримый /logs?action_type=...), в
// отличие от frontend/ (Telegram WebView, стек экранов без роутера).
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/', element: <Navigate to="/dashboard" replace /> },
  {
    element: <ProtectedLayout />,
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/users', element: <UsersPage /> },
      { path: '/admins', element: <AdminsPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/logs', element: <LogsPage /> },
      // PARA-129, AC-21: отдельный раздел; /logs остаётся без изменений.
      { path: '/monitoring', element: <MonitoringPage /> },
    ],
  },
]);
